import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './PaymentOnDayCard.module.css'

interface PaymentOnDayCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function PaymentOnDayCard({ score = 0, maxScore = 0, status = 'EM_DIA' }: PaymentOnDayCardProps) {


    const setMessage = () => {
        if (status === 'EM_DIA') {
            return (
                <div className='margin-top-20'>
                    Pagamento confirmado <span className='text-bold'>dentro do prazo</span>.
                </div>
            )
        } else if (status === 'ATRASO') {
            return (
                <div className='margin-top-20'>
                    <div>O último pagamento teve <span className='text-bold'>atraso acima de 5 dias</span>.  <span className='text-bold'>Regularize</span> para preservar sua pontuação.</div>
                </div>
            )
        } else {
            return (
                <div className='margin-top-20'>
                    <div>Sua pontuação foi impactada por <span className='text-bold'>faturas em aberto</span>. <span className='text-bold'>Pague sempre suas contas em dia</span> para garantir sua pontuação.</div>
                </div>
            )
        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Pagamento em Dia</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                {status === "EM_DIA" ? (
                                    <div>
                                        <span style={{ fontSize: 42 }} className='rioglyph rioglyph-ok-circle text-color-black'></span>
                                    </div>
                                ) : (
                                    <div style={{ fontSize: 40 }}>
                                        <span className={styles["current-score"]}>{score}</span>
                                        <span className={styles["total-score"]}>/ {maxScore}</span>
                                    </div>
                                )}
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}